// extracted by mini-css-extract-plugin
module.exports = {"main":"login_main_2WIST","arrow":"login_arrow_3sAV4"};